import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app.routing';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import packageJson from '../package.json';
//import { ObservabilityModule } from '@michelin/observability';
import { EnvConfigurationService } from './app/shared/services/envconf.service';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthModule } from '@michelin/auth';
import { JwtAuthInterceptor } from "./app/shared/services/jwt-auth.interceptor";
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      })
    }),
    //importProvidersFrom(
    //  ObservabilityModule.forRoot({
    //    app: {
    //      name: packageJson.name,
    //      version: packageJson.version,
    //      environment: EnvConfigurationService.getEnv()
    //    }
    //  })
    //),
    importProvidersFrom(AuthModule.forRoot(EnvConfigurationService.getAuthConfigEnv())),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtAuthInterceptor,
      multi: true
    }
  ]
}).catch((err) => console.error(err));
